import { Box, Typography } from "@mui/material";
import React from "react";
import StyledPrimaryButton from "../atoms/buttons/styledPrimaryButton.styled";

interface GenesysLoadErrorNoticeProps {
  onRetry: () => void;
}

// Card-style hint shown on the welcome page when loading the Genesys SDK failed,
// with an action to retry — instead of letting the user proceed into a silently
// broken chat. The filled retry button and the tinted border derive from the
// active brand's primary color, so the card reflects each of the four themes.
const GenesysLoadErrorNotice = ({
  onRetry,
}: GenesysLoadErrorNoticeProps): React.JSX.Element => (
  <Box
    role="alert"
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      textAlign: "center",
      gap: "20px",
    }}
  >
    <Typography
      sx={{
        fontSize: "1.0625rem",
        fontWeight: 600,
        color: "rgba(0, 0, 0, 0.8)",
      }}
    >
      Der Chat ist gerade nicht verfügbar.
    </Typography>
    <StyledPrimaryButton onClick={onRetry} fullWidth variant="contained">
      Erneut versuchen
    </StyledPrimaryButton>
  </Box>
);

export default GenesysLoadErrorNotice;
